<div class="form-field" [formGroup]='parent' style="display: none;"
    [attr.aria-describedBy]="'lbl-'+pageName+'-'+controllerData.controlName">
    <label [id]="'lbl-'+pageName+'-'+controllerData.controlName" [attr.for]="pageName+'-'+controllerData.controlName"
        class="form-label">{{controllerData['label']}}</label>
    <input [formControlName]="controllerData['controlName']" [name]="controllerData['name']" aria-required="true"
        type="hidden" [id]="pageName+'-'+controllerData['name']" [(ngModel)]="textValue"
        [placeholder]="controllerData['placeHolder']" maxlength="14" class="form-control"
        [ngClass]=" (router.url !== '/quote/your-product-options') ? 'modalClose-focus' : '' " [value]="textValue"
        [required]="controllerData['required']"
        [attr.aria-describedBy]="'input-'+pageName+'-'+controllerData.controlName" inputmode="numeric" />
</div>

<form [formGroup]="selectForm">
    <div class="form-group">
        <div *ngIf="!allowFutureDate">
            <label [id]="'lbl-'+pageName+'-'+controllerData.controlName" [attr.for]="pageName+'-'+controllerData.controlName"
                class="form-label">{{controllerData['label']}}</label>
        </div>
       
        <div [ngClass]="allowFutureDate? 'col-md-12 clear-all mar-pad-0':'col-md-12 calender-container'">
            <div [ngClass]="allowFutureDate? 'col-md-12 clear-all flex-container mini-gap  ':'col-md-12 clear-all flex-container'">
                <div class="form-field flex-30">
                    <div class="form-field-select">
                        <select id="day"
                            [ngClass]="{'invalid-error-border': (parent.get(controllerData.controlName).touched && (selectForm.get('day').errors || selectForm.get('month').errors || selectForm.get('year').errors || !isValidDateSelected))}"
                            class="form-control fixed-width" aria-required="true" [required]="true"
                            [attr.aria-invalid]="(parent.get(controllerData.controlName).touched && (selectForm.get('day').errors || selectForm.get('month').errors || selectForm.get('year').errors || !isValidDateSelected)) ? true : false"
                            formControlName="day" [(ngModel)]="selectedDay" (change)="onChangeOfDropdown($event)"
                            (blur)="onChangeOfDropdown($event)">
                            <option [ngValue]="null" [disabled]="false">Day</option>
                            <option *ngFor="let day of days; let i = index" [id]="i+1" [value]="i+1">{{ day }}</option>
                        </select>
                        <i class="icon icon-chevron-down" aria-hidden="true"></i>
                    </div>
                </div>
                <div class="form-field flex-40">
                    <div class="form-field-select">
                        <select id="month"
                            [ngClass]="{'invalid-error-border': (parent.get(controllerData.controlName).touched && (selectForm.get('day').errors || selectForm.get('month').errors || selectForm.get('year').errors || !isValidDateSelected))}"
                            class="form-control fixed-width" aria-required="true" [required]="true"
                            [attr.aria-invalid]="(parent.get(controllerData.controlName).touched && (selectForm.get('day').errors || selectForm.get('month').errors || selectForm.get('year').errors || !isValidDateSelected)) ? true : false"
                            formControlName="month" [(ngModel)]="selectedMonth" (change)="onChangeOfDropdown($event)"
                            (blur)="onChangeOfDropdown($event)">
                            <option [ngValue]="null" [disabled]="false">Month</option>
                            <option *ngFor="let month of months; let i = index" [id]="i + 1" [value]="i + 1">{{ month }}
                            </option>
                        </select>
                        <i class="icon icon-chevron-down" aria-hidden="true"></i>
                    </div>
                </div>

                <div class="form-field flex-30">
                    <div class="form-field-select">
                        <select id="year"
                            [ngClass]="{'invalid-error-border': (parent.get(controllerData.controlName).touched && (selectForm.get('day').errors || selectForm.get('month').errors || selectForm.get('year').errors || !isValidDateSelected))}"
                            class="form-control fixed-width" aria-required="true" [required]="true"
                            [attr.aria-invalid]="(parent.get(controllerData.controlName).touched && (selectForm.get('day').errors || selectForm.get('month').errors || selectForm.get('year').errors || !isValidDateSelected)) ? true : false"
                            formControlName="year" [(ngModel)]="selectedYear" (change)="onChangeOfDropdown($event)"
                            (blur)="onChangeOfDropdown($event)">
                            <option [ngValue]="null" [disabled]="false">Year</option>
                            <option *ngFor="let year of years; let i = index" [id]="year" [value]="year">{{ year }}
                            </option>
                        </select>
                        <i class="icon icon-chevron-down" aria-hidden="true"></i>
                    </div>
                </div>
            </div>
        </div>

        <div class="form-validation-error"
            *ngIf="parent.get(controllerData.controlName).touched &&
      (selectForm.get('day').errors || selectForm.get('month').errors || selectForm.get('year').errors  || !isValidDateSelected)">
            <i class="icon icon-error" aria-hidden="true"></i>
            <p [id]="controlName +'-error'" *ngIf=" !(allowFutureDate && isStartDateThreeMonthsError) || isInvalidDate">
                {{"Please enter a valid date"}}
            </p>
            <p [id]="controlName +'-error'" *ngIf="allowFutureDate && isStartDateThreeMonthsError && !isInvalidDate">
                {{controllerData['StartDateThreeMonthsError']}}
            </p>
        </div>
    </div>
</form>